/* eslint-disable no-alert */
import React from 'react';
import _ from 'lodash';
import {
  FormControl,
  Button,
  Box,
  Typography,
  Stack,
  CircularProgress
} from '@mui/material';

import { useMutation, useParameterizedQuery } from 'react-fetching-library';
import { uploadFormSchemaAction, monthDay1Test, monthDay1TestSendMails, generateDeductions } from '../../services/request';

export const FormSchemaUploadPanel = () => {
  const { mutate } = useMutation(uploadFormSchemaAction);
  const [fileData, setFileData] = React.useState(null);
  const [fileContent, setFileContent] = React.useState(null);
  const [responseMessage, setResponseMessage] = React.useState('');
  const { query: day1Query, loading: day1Loading } = useParameterizedQuery(monthDay1Test);
  const { query: day1SendMailQuery, loading: sendLoading } = useParameterizedQuery(monthDay1TestSendMails);
  const { query: generateDeductionsQuery, loading: generateDeductionsLoading } = useParameterizedQuery(generateDeductions);

  const day1Click = async () => {
    const { error, payload } = await day1Query();
    console.log(payload);
    if (!error) {
      alert('płatności zostały wygenerowane');
    } else {
      alert('nie udało się wygenerować płatności');
    }
  };

  const day1SendMailClick = async () => {
    const { error, payload } = await day1SendMailQuery();
    console.log(payload);
    if (!error) {
      alert('maile zostały wysłane');
    } else {
      alert('nie udało się wysłać maili');
    }
  };

  const generujPotraceniaClick = async () => {
    const { error, payload } = await generateDeductionsQuery();
    console.log(payload);
    if (!error) {
      alert('Wygenerowano potracenia');
    } else {
      alert('Nie udało się wygenerowac potracen');
    }
  };

  const handleFileSelect = e => {
    setFileData(e.target.files[0]);
    const r = new FileReader();
    r.readAsText(e.target.files[0]);
    r.onload = e => {
      setFileContent(e.target.result);
    };
  };

  const handleSubmit = async() => {
    const { error, payload } = await mutate({ json_data: fileContent });
    console.log(payload);
    if (!error) {
      setResponseMessage('Wgrano formularz');
    } else {
      console.log(payload);
      setResponseMessage(payload.message);
    }
  };


  return (
    <>
      <Box>
        <FormControl>
          <Button variant="contained" component="label">
            Wczytaj plik
            <input type="file" hidden onChange={e => handleFileSelect(e)} />
          </Button>
          <Typography
            style={{ wordWrap: 'break-word', overflow: 'hidden' }}
            // noWrap
            variant="caption"
            align="center"
          >
            {!_.isNull(fileData) ? fileData.name : ''}
          </Typography>
        </FormControl>
        <Button
          disabled={_.isNull(fileContent)}
          color="primary"
          variant="contained"
          onClick={() => handleSubmit()}
        >
          Zapisz
        </Button>
        <p>{responseMessage}</p>
      </Box>
      <Stack sx={{ mt: 4, width: '300px' }}>
        <Button fullWidth variant="contained" onClick={day1Click} disabled={day1Loading}>Generuj Płatności {day1Loading ? <CircularProgress size={12} /> : null}</Button>
        <Button fullWidth variant="contained" onClick={day1SendMailClick} disabled={sendLoading} sx={{ mt: 2 }}>Wyślij mail {sendLoading ? <CircularProgress size={12} /> : null}</Button>
        <Button fullWidth variant="contained" onClick={generujPotraceniaClick} disabled={generateDeductionsLoading} sx={{ mt: 2 }}>Generuj potracenia{generateDeductionsLoading ? <CircularProgress size={12} /> : null}</Button>
      </Stack>
    </>
  );
};
